/**
 * Підписка на SSE schema-changed події для конкретної таблиці.
 * Повертає функцію відписки.
 *
 * onChanged() викликається коли сервер емітить schema-changed —
 * компонент перезавантажує схему.
 */

const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';
// SSE endpoint живе на тому самому origin що й API, але без /api префіксу
// Витягуємо базовий origin з VITE_API_BASE (напр. http://localhost:3002/api → http://localhost:3002)
function sseBase(): string {
  try {
    const url = new URL(API_BASE);
    return url.origin;
  } catch {
    return '';
  }
}

export function subscribeSchemaSSE(
  slug: string,
  onChanged: () => void,
  /** Викликається на record-changed (create/update/delete) — для realtime
   *  оновлення Kanban-дошки. Опційний (backward-compat). */
  onRecordChanged?: () => void,
): () => void {
  const url = `${sseBase()}/api/schema-sse/${slug}`;
  let es: EventSource | null = null;
  let closed = false;
  let retryTimer: ReturnType<typeof setTimeout> | null = null;

  function connect() {
    if (closed) return;
    es = new EventSource(url, { withCredentials: true });

    es.addEventListener('schema-changed', () => {
      onChanged();
    });

    if (onRecordChanged) {
      es.addEventListener('record-changed', () => {
        onRecordChanged();
      });
    }

    es.onerror = () => {
      es?.close();
      es = null;
      if (!closed) {
        // Retry після 5с
        retryTimer = setTimeout(connect, 5000);
      }
    };
  }

  connect();

  return () => {
    closed = true;
    if (retryTimer) clearTimeout(retryTimer);
    es?.close();
  };
}
